import { useMutation } from "@tanstack/react-query";

import { INoContentResponse } from "@krea/shared/types/response";

import { markSigningUrlClicked } from "@/services/api/lender-response/actions";

export const useMarkSigningUrlClicked = () => {
  return useMutation<INoContentResponse, Error, { lenderResponseID: string }>({
    mutationFn: async ({ lenderResponseID }) => {
      await markSigningUrlClicked(lenderResponseID);
    },
    onError: () =>
      console.error(`Failed to send data for "markSigningUrlClicked"`),
  });
};
